import { ResumePage } from '@/pages/resume'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_authed/resume')({
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).catch(1)
  }),
  component: ResumePage,
})